import React from "react";
import "./What_WinGo_Offers.css";
import Common_Title from "../../Common/Common_Component/Common_Title/Common_Title";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";

function What_WinGo_Offers() {
  return (
    <>
      <section className="What_WinGo_Offers">
        <Common_Title title="What WinGo Offers"/>

         <Swiper
          modules={[Pagination, Autoplay]}
          spaceBetween={5}
          slidesPerView={2.2}
          pagination={{ clickable: true }}
        //   autoplay={{ delay: 3000 }}
          loop={true}
          className="What_WinGo_Offers_slider common_swiper"
        >
          {/* Slide 1 */}
          <SwiperSlide>
            <div className="img_holder">
              <img src="/assets/images/home/what_WinGo_Offers/img_1.png" alt="banner img" className="What_WinGo_Offers_img"/>
            </div>
          </SwiperSlide>

          {/* Slide 2 */}
          <SwiperSlide>
            <div className="img_holder">
              <img src="/assets/images/home/what_WinGo_Offers/img_2.png" alt="banner img" className="What_WinGo_Offers_img"/>
            </div>
          </SwiperSlide>

          {/* Slide 3 */}
          <SwiperSlide>
             <div className="img_holder">
              <img src="/assets/images/home/what_WinGo_Offers/img_3.png" alt="banner img" className="What_WinGo_Offers_img"/>
            </div>
          </SwiperSlide>

           {/* Slide 1 */}
          <SwiperSlide>
            <div className="img_holder">
              <img src="/assets/images/home/what_WinGo_Offers/img_1.png" alt="banner img" className="What_WinGo_Offers_img"/>
            </div>
          </SwiperSlide>

          {/* Slide 2 */}
          <SwiperSlide>
            <div className="img_holder">
              <img src="/assets/images/home/what_WinGo_Offers/img_2.png" alt="banner img" className="What_WinGo_Offers_img"/>
            </div>
          </SwiperSlide>

          {/* Slide 3 */}
          <SwiperSlide>
             <div className="img_holder">
              <img src="/assets/images/home/what_WinGo_Offers/img_3.png" alt="banner img" className="What_WinGo_Offers_img"/>
            </div>
          </SwiperSlide>
        </Swiper>
      </section>
    </>
  );
}

export default What_WinGo_Offers;
